import { useSafeLayoutEffect } from './useSafeLayoutEffect';

const CLASSNAME = 'scroll-lock';

export const useScrollLock = (isOpen: boolean) => {
  useSafeLayoutEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add(CLASSNAME);
      document.body.classList.add(CLASSNAME);
    } else {
      document.documentElement.classList.remove(CLASSNAME);
      document.body.classList.remove(CLASSNAME);
    }
    return () => {
      document.documentElement.classList.remove(CLASSNAME);
      document.body.classList.remove(CLASSNAME);
    };
  }, [isOpen]);
};
